import APIController from '../core-api-controller';

export const fetchContactsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/contacts${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};
